import _ from 'lodash';

export const isPractitioner = ({ email, username, roles }) =>
  _.includes(roles, 'practitioner') || _.toLower(email) === _.toLower(username);
